import { createApp } from 'vue'
import Product from '~/js/models/product'
import { isDesktop } from '~/js/templates/index/helpers'
import FButtonAddToCart from '~/js/components/buttonAddToCart'
import FProductCardPrice from '~/js/components/productCard/price'
import { ItemAddToCart } from '~/js/components/buttonAddToCart'

const ID = 'js-pageAddToCart'

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return

  const searchString = location.search.replace(/^\?/, '')
  const urlSearchParams = new URLSearchParams(searchString)

  const idsString = urlSearchParams.get('ids')
  const ids = (idsString || '').split(',')
  const quantitiesString = urlSearchParams.get('quantities')
  const itemQuantities = (quantitiesString || '')
    .split(',')
    .map((string) => Number(string))
  const isParameterValid =
    ids.length &&
    ids.every((value) => value) &&
    itemQuantities.length &&
    itemQuantities.every((value) => value > 0) &&
    ids.length === itemQuantities.length

  const getItemInfo = async (id) => {
    return await $.ajax({
      type: 'get',
      url: '/search',
      data: {
        q: `id:${id}`,
        type: 'product',
        view: 'product-json',
        'options[unavailable_products]': 'show',
      },
    }).then((result) => {
      const product = JSON.parse(result)
      return product
    })
  }

  Promise.all(
    ids.map(async (id) => {
      return await getItemInfo(id)
    })
  )
    .then((items) => {
      const products = []
      if (isParameterValid) {
        items.forEach((item, index) => {
          if (Object.keys(item).length) products.push(new Product(item))
          else itemQuantities.splice(index, 1)
        })
      }

      const itemsToAddCart = products
        .filter((product) => !product.isSoldout && !product.isBackstock)
        .map(
          (product, index) =>
            new ItemAddToCart({ ...product, quantity: itemQuantities[index] })
        )

      createApp({
        name: 'PageAddToCart',
        data() {
          return {
            products,
            isDesktop: isDesktop(),
            itemsToAddCart,
            itemQuantities,
            size: isDesktop() ? undefined : 'small',
          }
        },
        components: {
          FButtonAddToCart,
          FProductCardPrice,
        },
        created() {
          element.style.display = 'block'
        },
      }).mount(element)
    })
    .catch((e) => {
      console.error(e)
    })
})
